import { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IAuftrag } from '../../types/Types';
import { formatToEuroDateTime } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import { useSearchAuftraegeMutation } from '../../api/AuftragAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';

/**
 * @author noone
 */
export default function AuftragSearch() {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const [searchAuftragAPI] = useSearchAuftraegeMutation();

    const [suchFeld, setSuchFeld] = useState<string>("");

    const [auftragslisteGesamt, setAuftragslisteGesamt] = useState<IAuftrag[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const suche = () => {

        setIsLoading(true);

        const suchbegriffe = suchFeld.trim().split(" ");
        searchAuftragAPI({
            woerter: suchbegriffe
        }).unwrap()
            .then(data => setAuftragslisteGesamt(data))
            .catch((error) => console.log(error))
            .finally(() => {
                setIsLoading(false);
            })
            ;
    }

    useEffect(() => {
        suche();
    }, [searchAuftragAPI]);

    return (
        <div>

            <LandingpageHeader />

            <LoadingModal show={isLoading} />

            <div style={{ padding: "20px" }}>

                <button
                    onClick={() => {
                        navigate({
                            pathname: "/",
                            search: ""
                        });
                    }}

                    style={{ marginBottom: "20px" }}
                    className=' btn btn-outline-primary'
                >
                    <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                </button>


                <h4 style={{ textAlign: "center" }}>Auftragssuche</h4>

                <form onSubmit={(e) => { e.preventDefault(); suche(); }} >
                    <input type="text" className='form-control' placeholder='Suche' value={suchFeld} onChange={(e) => setSuchFeld(e.target.value)} />
                    <button type="submit" className='btn btn-primary' style={{ marginTop: "10px" }}>Suchen</button>
                </form>

                {auftragslisteGesamt?.length === 0 && <div>Keine Aufträge vorhanden</div>}

                <table className="table" style={{ width: "100%", marginTop: "20px" }}>
                    <thead>
                        <tr>
                            <th scope="col">Status</th>
                            <th scope="col">Art</th>
                            <th scope="col">Name</th>
                            <th scope="col">Strasse</th>
                            <th scope="col">Stadt</th>
                            <th scope="col">Email</th>
                            <th scope="col">Termin</th>
                            <th scope="col">Aktionen</th>
                        </tr>
                    </thead>
                    <tbody>
                        {auftragslisteGesamt?.map((auftrag, index) => (
                            <tr key={index}>

                                <td>{auftrag.status}</td>
                                <td>{auftrag.art}</td>
                                <td>{auftrag.name_endkunde}</td>
                                <td>{auftrag.strasse_lieferadresse} {auftrag.hausnummer_lieferadresse}</td>
                                <td>{auftrag.stadt_lieferadresse}</td>
                                <td>{auftrag.email_lieferadresse}</td>
                                <td>{formatToEuroDateTime(auftrag.aktuellerTermin)}</td>
                                <td>
                                    <button
                                        className="btn btn-primary"
                                        onClick={(event: FormEvent) => {
                                            event.stopPropagation();
                                            window.open(
                                                "./.auftragdetails?uid=" + auftrag?.uid + "&backbuttonClose=true",
                                                "_blank"
                                            );
                                        }} ><i className='bi bi-pencil-fill'></i></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>




            </div >
            <Footer />
        </div >
    );

}

